import { c as _c } from "react/compiler-runtime";
import SubHeader from "./SubHeader";
import MainHeader from "./MainHeader";
import TypingHeader from "./TypingHeader";
import { HeaderIconName } from "@/shared/types/type/icon";
interface HeaderProps {
  type?: "main" | "sub" | "typing";
  title?: string;
  subHeaderLeftButtons?: HeaderIconName[];
  subHeaderRightButtons?: HeaderIconName[];
  typeingHeaderLeftButtons?: HeaderIconName[];
  typeingHeaderRightButtons?: HeaderIconName[];
}
const Header = t0 => {
  const $ = _c(9);
  const {
    type: t1,
    title,
    subHeaderLeftButtons,
    subHeaderRightButtons,
    typeingHeaderLeftButtons,
    typeingHeaderRightButtons
  } = t0;
  const type = t1 === undefined ? "main" : t1;
  if (type === "sub") {
    let t2;
    if ($[0] !== subHeaderLeftButtons || $[1] !== subHeaderRightButtons || $[2] !== title) {
      t2 = <SubHeader title={title} leftButtons={subHeaderLeftButtons} rightButtons={subHeaderRightButtons} />;
      $[0] = subHeaderLeftButtons;
      $[1] = subHeaderRightButtons;
      $[2] = title;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  if (type === "typing") {
    let t2;
    if ($[4] !== title || $[5] !== typeingHeaderLeftButtons || $[6] !== typeingHeaderRightButtons) {
      t2 = <TypingHeader title={title} leftButtons={typeingHeaderLeftButtons} rightButtons={typeingHeaderRightButtons} />;
      $[4] = title;
      $[5] = typeingHeaderLeftButtons;
      $[6] = typeingHeaderRightButtons;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    return t2;
  }
  let t2;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <MainHeader />;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  return t2;
};
export default Header;